import React, { Fragment, Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { handleTracker } from '@source/lib/videoTracker';

import { getRecommendedArticles } from '@actions/recommended-articles';
import { getNewArticles } from '@actions/new-articles';

import ElasticFooter from '@components/ElasticFooter';
import CardCarouselFeatured from '@components/CardCarouselFeatured';
import ArticlesCardNew from '@components/ArticlesCardNew';
import Spinner from '@components/common/Spinner';
import ArticlesBanner from '@components/ArticlesBanner';
import s from './home.css';

import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy'
import _truncate from 'lodash/truncate';
import _upperFirst from 'lodash/upperFirst';
import { getHomeArticlesByIdx } from '@actions/home-articles';

class HomeDesktop extends Component {
  async componentDidMount() {
    this.props.fetchRecommendedArticles(
      this.props.runtime.article_category_featured_id
    );

    this.props.fetchHomeArticles(this.props.runtime.article_categories || []);
    this.props.fetchNewArticles();
  }

  render() {
    if (this.props.homeArticles.meta.status === 'loading') {
      return <Spinner />;
    }

    const featuredArticles = this.props.recommendedArticles.data.articles || [];
    const homeArticles = this.props.homeArticles.data || [];
    const newArticles = this.props.newArticles.data || [];
    const { configParams } = this.props
    const podcastList = _get(configParams, 'data.podcast_data.playlists', [])
    const podcastVis = _get(configParams, 'data.podcast_data.visibility', false)
    const podcastTitle = _get(configParams, 'data.podcast_data.title', 'Podcast')
    let latestPodcast = null
    if(podcastVis && podcastList.length > 0) {
      const arr = _orderBy(podcastList, 'publishDate', 'desc')
      latestPodcast = arr[0]
    }

    return (
      <Fragment>
        <div className={s.containerTop}>
          <div className={s.containerTopGrid}>
            {featuredArticles.length > 0 && (
              <Fragment>
                {featuredArticles.slice(0, 5).map(article => (
                  <div className={s.containerItem} key={article.id}>
                    <ArticlesBanner
                      id={article.id}
                      title={_truncate(article.title, {
                        length: 70
                      })}
                      imageUrl={article.imageUrl}
                    />
                  </div>
                ))}
              </Fragment>
            )}
          </div>
        </div>

        { podcastVis &&
          <div className={s.main_container_margin}>
            <div className={s.header_container}>
              <span>{podcastTitle}</span>
              <a href="/category/podcast">View all</a>
            </div>
            {
              latestPodcast && 
              <div dangerouslySetInnerHTML={{__html: latestPodcast.content}}/>
            }
          </div>
        }

        {newArticles.length > 0 && (
          <div className={s.main_container}>
            <CardCarouselFeatured
              title={'Berita Terbaru'}
              initialSlideHeight={140}
              slidesToShow={3}
            >
              {newArticles.map(article => (
                <div className = {`${s.container} ${s.recent__container}`}
                  key={article.id}
                >
                  <ArticlesCardNew
                    time={article.createdAt}
                    id={article.id}
                    title={article.title}
                    // title={_truncate(article.title, {
                    //   length: 50
                    // })}
                    imageUrl={article.imageUrl}
                    slidesToShow={3}
                  />
                </div>
              ))}
            </CardCarouselFeatured>
          </div>
        )}

        {homeArticles.map(category => {
          const categoryName = _upperFirst(category.data.attributes.title);
          const articles = category.data.attributes.articles;

          return (
            <div className={s.main_container} key={category.id}>
              {articles &&
                articles.length > 0 && (
                <CardCarouselFeatured
                  title={categoryName}
                  initialSlideHeight={140}
                  slidesToShow={4}
                >
                  {articles.map(article => (
                    <div className = {`${s.container} ${s.category__container}`}
                    key={article.id}
                  >
                    <ArticlesCardNew
                      key={article.id}
                      time={article.attributes.createdAt}
                      id={article.id}
                      title={_truncate(article.attributes.title, {
                        length: 70
                      })}
                      imageUrl={article.attributes.imageUrl}
                    />
                    </div>
                  ))}
                </CardCarouselFeatured>
              )}
            </div>
          );
        })}

        <ElasticFooter />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return { ...state };
};

const mapDispatchToProps = dispatch => ({
  fetchRecommendedArticles: pathName =>
    dispatch(getRecommendedArticles(pathName)),
  fetchNewArticles: () => dispatch(getNewArticles()),
  fetchHomeArticles: articleIds => dispatch(getHomeArticlesByIdx(articleIds))
});

export default compose(
  withStyles(s),
  connect(mapStateToProps, mapDispatchToProps)
)(HomeDesktop);
